export async function reloadProjectIntegration({api, projectId, integrationId, onIntegrationRefreshed}) {
    const integrations = await api.listProjectIntegrations({projectId});
    const refreshedIntegration = integrations.find((integration) => integration.id === integrationId);

    if (refreshedIntegration) {
        onIntegrationRefreshed(refreshedIntegration);
    }

    return refreshedIntegration ?? null;
}

export async function refreshOAuthIntegrationResources(parameters) {
    const {api, projectId, integrationId} = parameters;
    try {
        await api.refreshProjectOAuthIntegrationResources({projectId, integrationId});
    } catch (error) {
        try {
            await reloadProjectIntegration(parameters);
        } catch {
            // Preserve the provider refresh error, which is the actionable error for this interaction.
        }
        throw error;
    }
    return reloadProjectIntegration(parameters);
}
